/** Shared defaults for template review preview (example + structure tabs). */
export const DEFAULT_EXAMPLE_CONTENT = `History
- Reports sudden onset of central chest pain for the last 4 hours
- Describes the pain as sharp, rated 6/10 at rest, increasing to 8/10 on deep inspiration. The pain is not radiating.
- Leaning forward provides slight relief, but rest does not.
- Associated symptoms include shortness of breath, tachypnoea, palpitations, and light-headedness.
- Reports a cough for the past 4 hours, with haemoptysis noted one hour ago.
- Reports right leg swelling and pain for the past 2 days, which began after a long flight.

Past Medical History
- Hypertension
- Hypercholesterolaemia
- Obesity
- Smoking history
- Family history of DVT

Physical Examination:
- Tachycardic
- Tachypnoeic
- Hypotensive`;

export const DEFAULT_STRUCTURE_CONTENT = `History
- [Presenting complaint]
- [Description of symptoms]
- [Associated symptoms]

Past Medical History
- [Relevant conditions]

Physical Examination:
- [Vital signs]
- [Examination findings]`;
